// Import dependencies
import './condition';

import { AutomatorTemplateActionFilterBase } from '@automator/features/page-template-library/components/template-filter/_base';
import { unsafeCSS, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-template-loop-action-filter' )
export class AutomatorTemplateLoopActionFilter extends AutomatorTemplateActionFilterBase {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * Creates the template that shows the conditions
	 *
	 * @return {TemplateResult} The conditions
	 */
	get _templateConditions() {
		return html`
			<div class="conditions">
				${ repeat(
					this.conditions,
					( item, index ) => index,
					condition => html`
						<uap-template-loop-action-filter-condition
							integration-code=${ condition.integration_code }
							.title=${ condition.title }
							.titleHTML=${ condition.title_html }
						></uap-template-loop-action-filter-condition>
					`
				) }
			</div>
		`;
	}

	/**
	 * Creates the section that shows all the actions
	 *
	 * @return {TemplateResult} The actions
	 */
	get _templateItems() {
		return html`
			<div class="filter-block-items">
				${ repeat(
					this.items,
					( item, index ) => index,
					item => html`
						<uap-template-loop-action 
							integration-code=${ item.integration_code }
							.title=${ item.title }
							.titleHTML=${ item.title_html }
							.delay=${ item.delay }

							?is-pro=${ item.is_pro }
							?is-elite=${ item.is_elite }
						></uap-template-loop-action>
					`
				) }
			</div>
		`;
	}
}